// Booster-сборка (VITE_PRODUCT=booster): профайлер недоступен, поэтому
// каталог полей профайлера в клиентский бандл попадать НЕ должен.
//
// resources_profiler.ts тянется booster-достижимым кодом (App.tsx импортирует
// isProfilerFieldVisible/getProfilerFieldsForSection, ScriptTree.tsx —
// PROFILER_RESOURCES). Эти функции итерируют PROFILER_RESOURCES, поэтому
// tree-shaking не может выкинуть каталог и его строки («Прогрев профиля»,
// STATUS_BOOST_MODE, MODE_PROGREV_TYPE…) утекают в index-*.js.
//
// В vite.config.ts для booster этот файл алиасится вместо resources_profiler,
// разрывая статический импорт настоящего каталога из booster-графа.
// Типы (erased на компиляции) держим в resources_types.ts — строк не несут.
// В full-сборке (VITE_PRODUCT=full) алиас не активен → используется реальный
// resources_profiler.ts, профайлер работает полноценно.

import type { FieldType, VisibleWhen, ResourceDef } from './resources_types'
export type { FieldType, VisibleWhen, ResourceDef }

export const PROFILER_SECTIONS = [] as const

export type ProfilerSectionName = string

export const PROFILER_RESOURCES: Record<string, ResourceDef> = {}

export function getProfilerFieldsForSection(
  _section: any,
  _isAdmin?: boolean,
): Array<[string, ResourceDef]> {
  return []
}

export function isProfilerFieldVisible(
  _variable: string,
  _cfg: Record<string, any>,
  _seen?: Set<string>,
): boolean {
  return false
}

export function getProfilerDefaults(): Record<string, any> {
  return {}
}
